
export const ServiceCardSkeleton = () => {
  return (
    <div className="lp-relative">
      <div className="lp-group lp-relative lp-overflow-hidden lp-bg-black/95 lp-backdrop-blur-sm
        lp-border lp-border-[#DDB889]/10 lp-rounded-2xl
        lp-h-full lp-flex lp-flex-col
        lp-shadow-[0_0_15px_rgba(221,184,137,0.07)]">

        {/* Image skeleton */}
        <div className="lp-relative lp-h-48 lp-shrink-0">
          <div className="lp-absolute lp-inset-0 lp-bg-gray-800 animate-pulse" />

          {/* Info Badges skeleton */}
          <div className="lp-absolute lp-bottom-4 lp-left-4 lp-right-4 lp-flex lp-justify-between lp-items-center">
            <div className="lp-bg-gray-800 lp-w-20 lp-h-8 lp-rounded-xl animate-pulse" />
            <div className="lp-bg-gray-800 lp-w-24 lp-h-8 lp-rounded-xl animate-pulse" />
          </div>
        </div>

        {/* Content Section skeleton */}
        <div className="lp-p-6 lp-flex lp-flex-col lp-flex-1 lp-gap-4">
          {/* Title skeleton */}
          <div className="lp-flex lp-gap-2 lp-items-start">
            <div className="lp-w-5 lp-h-5 lp-bg-gray-800 lp-rounded animate-pulse" />
            <div className="lp-flex-1">
              <div className="lp-h-6 lp-bg-gray-800 lp-rounded animate-pulse" />
            </div>
          </div>

          {/* Description skeleton */}
          <div className="lp-flex lp-gap-2">
            <div className="lp-w-5 lp-h-5 lp-bg-gray-800 lp-rounded animate-pulse" />
            <div className="lp-flex-1 lp-space-y-2">
              <div className="lp-h-4 lp-bg-gray-800 lp-rounded animate-pulse" />
              <div className="lp-h-4 lp-bg-gray-800 lp-rounded animate-pulse lp-w-3/4" />
              <div className="lp-h-4 lp-bg-gray-800 lp-rounded animate-pulse lp-w-1/2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ServiceSelectionSkeleton = () => {
  return (
    <div className="lp-grid lp-grid-cols-1 md:lp-grid-cols-2 lg:lp-grid-cols-3 lp-gap-6 lp-auto-rows-fr">
      {[...Array(3)].map((_, index) => (
        <ServiceCardSkeleton key={index} />
      ))}
    </div>
  );
};
